/**
 * The page for an address that has nothing at it.
 *
 * It was `<div>404 - Page Not Found</div>`: unstyled, no ground, no way
 * anywhere. This says what happened in words and offers the two places a
 * person here is most likely trying to reach.
 */
import { useEffect } from 'react'
import { ButtonLink } from '@/design-system/primitives'
import { Mark } from '@/design-system/shell'
import '@/design-system/tokens.css'
import '@/design-system/components.css'
import '@/design-system/feedback.css'

export default function NotFoundPage() {
  useEffect(() => {
    document.title = 'Page not found | SuperSchema'
  }, [])

  return (
    <div className="ds ds-boot">
      <main className="ds-boot__in ds-boot__in--words">
        <div className="ds-boot__brand" aria-hidden="true">
          <Mark size={30} />
          <span>SuperSchema</span>
        </div>
        <h1 className="ds-h2">There is nothing at this address</h1>
        <p className="ds-lead">The link may be old, or the page may have moved.</p>
        <div className="ds-boot__acts">
          <ButtonLink to="/">Go to the homepage</ButtonLink>
          <ButtonLink to="/dashboard" variant="secondary">
            Open my dashboard
          </ButtonLink>
        </div>
      </main>
    </div>
  )
}
